<script>
  import Technologies from '../components/technologies.svelte';
  import BouncingArrow from '../components/bouncing-arrow.svelte';

  export let info = {};

  let title = '';
  let currentTitleIndex = 0;
  
  const typeSpeed = 80;
  const deleteSpeed = 50;
  const waitTime = 3000;
  let isDeleting = false;
  
  function typeWriter() {
    const currentTitle = info.titles[currentTitleIndex];
    
    if (isDeleting) {
      title = currentTitle.substring(0, title.length - 1);
      
      if (title === '') {
        isDeleting = false;
        currentTitleIndex = (currentTitleIndex + 1) % info.titles.length;
        setTimeout(typeWriter, typeSpeed);
      } else {
        setTimeout(typeWriter, deleteSpeed);
      }
    } else {
      title = currentTitle.substring(0, title.length + 1);
      
      if (title === currentTitle) {
        setTimeout(() => {
          isDeleting = true;
          typeWriter();
        }, waitTime);
      } else {
        setTimeout(typeWriter, typeSpeed);
      }
    }
  }
  
  // Start the typewriter effect after component mounts
  setTimeout(() => {
    if (info.titles && info.titles.length > 0) {
      typeWriter();
    }
  }, 1000);
</script>

<div class="cover">
  <div class="cover-info">
    <div class="name">
      {info.name}
    </div>
    <div class="title">
      <span>{title}</span><span class="blinking">|</span>
    </div>
    <div class="tagline">{info.tagline}</div>
    <div class="main-action">
      <button class="btn btn-outline-secondary" type="button" on:click={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}>
        Let's talk!
      </button>
    </div>
  </div>
</div>
<div class="technologies">
  <BouncingArrow />
  <Technologies {info} />
</div>

<style>
  .name,
  .title {
    font-size: 1.2em;
    color: var(--base00);
    padding: 1em 0 0.5em 0;
  }

  .tagline {
    font-size: 0.6em;
    padding: 2em 0;
  }

  .technologies {
    position: absolute;
    top: calc(100% - 7em);
    left: 0;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .cover {
    height: 100%;
    text-align: center;
    font-size: 200%;
  }

  .cover-info {
    position: relative;
    top: 50%;
    transform: translateY(calc(-50% - 3.5em));
    z-index: 1;
  }

  .blinking {
    animation: blinkingText 1.2s infinite;
  }

  @keyframes blinkingText {
    0% {
      color: inherit;
    }
    49% {
      color: inherit;
    }
    60% {
      color: transparent;
    }
    99% {
      color: transparent;
    }
    100% {
      color: inherit;
    }
  }
</style>
